<template>
    <div class="main">
        <div class="notice">
            <div class="title">绑定须知：</div>
            <div class="content">只支持储蓄卡或借记卡<span style="color: #3B72FF;">(不支持农业银行、招商银行)，不支持 信用卡，</span>请勿向他人透露验证码，注意保护个人隐私 
            </div>
        </div>
        <div class="wrap">
            <div class="pro_box">
                <span class="label">持卡人</span>
                <input type="text"
                       placeholder="请输入持卡人姓名"
                       class="inputStyle"
                       v-model="realName">
            </div>

            <div class="pro_box" style="border: none;">
                <span class="label">身份证号</span>
                <input type="text"
                       placeholder="请输入身份证号"
                       class="inputStyle"
                       v-model="idCard">
            </div>
        </div>

        <div class="wrap">
            <div>
                <div class="bankInfo">
                    <span>请输入银行卡号</span>
                    <span class="label" style="color: #999999;">{{bankName}}</span>
                </div>

                <input type="text"
                       placeholder="请输入本人的银行卡号"
                       @input="inputChange"
                       class="inputStyle card"
                       v-model="bankCard">
            </div>


            <div class="pro_box">
                <span class="label">预留手机号</span>
                <input type="text"
                       placeholder="请输入银行绑定的预留手机号"
                       class="inputStyle"
                       v-model="phone">
            </div>
            <div class="inputCode">
                <div class="pro_box" style="border-bottom: none;">
                    <span class="label">验证码</span>
                    <input type="text"
                           placeholder="请输入验证码"
                           class="inputStyle"
                           v-model="code" style="width: 100px;">
                </div>
                <div class="code" @click="ysPaySign">{{codeMsg1}}</div>
            </div>

        </div>
        <div>
            <div class="btn"
                 @click="bindBank"><span>确认绑定</span>
            </div>
        </div>

        <Loading :isShow="loading1"></Loading>

        <Loading :isShow="loading2"></Loading>

    </div>
</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        name: "bankInfo",
        data() {
            return {
                prepaid: 0,
                realName: "",
                idCard: "",
                bankCard: "",
                bankName: "",
                phone: "",
                code: "",
                confirmCode: "",
                outTradeNo: "",
                protocolNo: "",
                paysn: "",
                scenceCode: 6,
                timer1: null,
                countdown1: 40,
                codeMsg1: "获取验证码",
                loading1: false,
                loading2: false
            }
        }, created() {
            this.util.title("绑定银行卡");
            this.creatOrder();
            this.getBankInfo();
        }, methods: {
            creatOrder() {
                //银行卡支付
                let param = {
                    memberType: 0, //后面会修改表中数据的
                    customerId: localStorage.getItem("customerId")
                        ? localStorage.getItem("customerId")
                        : "",
                    productId: 0,  //后面会修改表中数据的
                    memberOrderSource: "1",
                    price: 0,//后面会修改表中数据的
                    buyEntrance: 1, //1:会员，2：黑名单,
                    source: 2,
                };
                this.$post("/app/v1.0/memeber/submitMember2", param)
                    .then(res => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.prepaid = data.id;
                            this.outTradeNo = data.memberOrder;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    }).catch(err => {
                })
            },
            inputChange() {
                if (this.bankCard.trim().length != 6) {
                    return;
                }
                let param = {
                    bankCard: this.bankCard,
                };
                this.$get("/app/v1.0/payBank/getBankName", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.bankName = res.data;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });

            }, bindBank() {
                if (!this.realName) {
                    this.util.toast({msg: "持卡人不能为空"})
                    return;
                }
                if (!this.idCard) {
                    this.util.toast({msg: "身份证号不能为空"})
                    return;
                }
                if (!this.bankCard) {
                    this.util.toast({msg: "银行卡号不能为空"})
                    return;
                }
                /*if (!this.bankName) {
                    this.util.toast({msg: "银行名称不能为空"})
                    return;
                }*/
                if (!this.phone) {
                    this.util.toast({msg: "预留手机号不能为空"})
                    return;
                }
                if (!this.code) {
                    this.util.toast({msg: "验证码不能为空"})
                    return;
                }
                let param = {
                    prepaid: this.prepaid,
                    mobileVerifyCode: this.code,
                    source: 1
                }
                this.loading2 = true;
                this.$post('/app/v1.0/payBank/ysFastPay/sign/confirm', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading2 = false;
                            this.protocolNo = e.data;
                            this.authSuccess();
                        } else {
                            this.loading2 = false;
                            this.util.toast({msg: "操作失败，已为您重新发送验证码，请输入新的验证码"})
                            this.closeTime1();
                            this.ysPaySign();
                        }
                    })
                    .catch(error => {
                        this.loading2 = false;
                    });
            }, getBankInfo() {
                this.$get("/app/v1.0/payBank/getBankInfo")
                    .then((res) => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.realName = data.userName;
                            this.idCard = data.idcard;
                            this.bankCard = data.bankCard;
                            this.bankName = data.bankName;
                            this.phone = data.phone;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });
            }, ysPaySign() {
                if (!this.codeMsg1.includes("获取验证码")) {
                    return;
                }
                if (!this.realName) {
                    this.util.toast({msg: "持卡人不能为空"})
                    return;
                }
                if (!this.idCard) {
                    this.util.toast({msg: "身份证号不能为空"})
                    return;
                }
                if (!this.bankCard) {
                    this.util.toast({msg: "银行卡号不能为空"})
                    return;
                }
                /*if (!this.bankName) {
                    this.util.toast({msg: "银行名称不能为空"})
                    return;
                }*/
                if (!this.phone) {
                    this.util.toast({msg: "预留手机号不能为空"})
                    return;
                }

                let param = {
                    prepaid: this.prepaid,
                    userName: this.realName,
                    idcard: this.idCard,
                    bankCard: this.bankCard,
                    bankName: this.bankName,
                    phone: this.phone
                }
                this.loading1 = true;
                this.$post('/app/v1.0/payBank/ysFastPay/sign', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading1 = false;
                            this.outTradeNo = e.data.outTradeNo;
                            this.prepaid = e.data.prepaid;
                            this.setTime1();
                            this.util.toast({msg: "发送成功"})
                        } else {
                            this.loading1 = false;
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                        this.loading1 = false;
                    });
            }, setTime1() {//倒计时1
                let _this = this;
                this.timer1 = setInterval(() => {
                    if (_this.countdown1 > 0 && _this.countdown1 <= 40) {
                        _this.countdown1--;
                        if (_this.countdown1 !== 0) {
                            _this.codeMsg1 = "重新发送(" + _this.countdown1 + ")";
                        } else {
                            clearInterval(_this.timer1);
                            _this.codeMsg1 = "获取验证码";
                            _this.countdown1 = 40;
                            _this.timer1 = null;
                        }
                    }
                }, 1000)
            }, closeTime1() {
                clearInterval(this.timer1);
                this.codeMsg1 = "获取验证码";
                this.countdown1 = 40;
                this.timer1 = null;
            }, authSuccess() { //调用android和ios的方法
                try {
                    window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.authSuccess(); //android
                }
            },


        }
    }
</script>

<style scoped>
    .main {
        background: #F7F7F7;
    }

    .wrap {
        margin: 0.12rem 0.15rem 0.1rem 0.15rem;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        background: #FFFFFF;
        border-radius: 0.08rem;
    }

    .wrap .bankInfo {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.1rem;
    }

    .notice {
        margin: 0.12rem 0.15rem 0.1rem 0.15rem;
        padding: 0.11rem 0.1rem 0.15rem 0.15rem;
        font-size: 0.12rem;
        background: #E8F0FF;
        border-radius: 0.08rem;
    }

    .notice .title {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.05rem;
    }

    .notice .content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    .pro_box {
        clear: both;
        overflow: hidden;
        border-bottom: 1px solid #eee;
        background: #fff;
    }

    .label {
        width: 0.75rem;
        font-family: PingFangSC-Regular, PingFang SC;
        display: inline-block;
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
    }

    .inputStyle {
        width: 70%;
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        padding: 0.15rem;
    }

    .card {
        border-radius: 4px;
        border: 1px solid #979797;
        width: 100%;
    }

    .btn {
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        color: #fff;
        border-radius: 0.25rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.17rem;
        text-align: center;
        line-height: 0.5rem;
        width: 95%;
        margin: 0 auto;
        margin-top: 0.3rem;
        margin-bottom: 0.1rem;
    }

    .btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    .desc .content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    input::-webkit-input-placeholder {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .inputCode {
        display: flex;
        justify-content: space-between;
    }

    .inputCode .code {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #527AF5;
        line-height: 50px;
        margin-right: 20px;
    }


</style>
